import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../button/Button';
import { correctHandler, omitHandler } from '../eventHandlers';
import {
    CORRECTIONS,
    INSERT_LEFT,
    INSERT_RIGHT,
    SUBSTITUTE,
} from '../../../constants/shared/ToolbarConstants';
import './Corrections.scss';

const Corrections = ({ wordPosition, corrections, setInputType, setWordEvent }) => {
    const [isOmitCorrection, isSubstituteCorrection, isInsertCorrection] = corrections;
    const isCorrectWord = !isOmitCorrection && !isInsertCorrection && !isSubstituteCorrection;

    return (
        <>
            <Button
                dataTestId="insert-left-correction"
                className="corrections insert"
                onClick={() => setInputType(INSERT_LEFT)}
                text={CORRECTIONS.INSERT_LEFT}
                isDisabled={isInsertCorrection}
            />
            <Button
                dataTestId="insert-right-correction"
                className="corrections insert"
                onClick={() => setInputType(INSERT_RIGHT)}
                text={CORRECTIONS.INSERT_RIGHT}
                isDisabled={isInsertCorrection}
            />
            <Button
                dataTestId="substitute-correction"
                className="corrections underline"
                onClick={() => setInputType(SUBSTITUTE)}
                text={CORRECTIONS.SUBSTITUTE}
                isDisabled={isInsertCorrection}
            />
            <Button
                dataTestId="omit-correction"
                className="corrections omit"
                onClick={() => omitHandler(wordPosition, setWordEvent)}
                text={CORRECTIONS.OMIT}
                isDisabled={isInsertCorrection || isOmitCorrection}
            />
            <Button
                dataTestId="correct-correction"
                className="corrections"
                onClick={() => correctHandler(wordPosition, isInsertCorrection, setWordEvent)}
                text={CORRECTIONS.CORRECT}
                isDisabled={isCorrectWord}
            />
        </>
    );
};

Corrections.defaultProps = {
    wordPosition: null,
    corrections: [],
    setInputType: () => '',
    setWordEvent: () => {},
};

Corrections.propTypes = {
    wordPosition: PropTypes.number,
    corrections: PropTypes.array,
    setInputType: PropTypes.func,
    setWordEvent: PropTypes.func,
};

export default Corrections;
